import * as React from "react";
import {
  DialogControlProvider
} from "./shared-ui-providers/index.js";
function EgenciaLayer(id, isOpen, setIsOpen, onDismiss, dialogQueryKey, locationHashUpdate) {
  const EgenciaLayerComponent = ({
    children
  }) => {
    function backButtonHandler() {
      if (new URLSearchParams(window.location.hash.slice(1)).get(dialogQueryKey)) {
        setIsOpen(true);
      } else if (isOpen) {
        setIsOpen(false);
      }
    }
    React.useEffect(() => {
      if (locationHashUpdate !== false) {
        window.addEventListener("popstate", backButtonHandler);
      }
      return function cleanup() {
        window.removeEventListener("popstate", backButtonHandler);
      };
    }, []);
    if (!isOpen) {
      return null;
    }
    const ref = React.useRef(null);
    const onClick = React.useCallback(
      (e) => {
        if (e.target === ref.current && onDismiss && typeof onDismiss === "function") {
          onDismiss();
        }
      },
      [onDismiss]
    );
    const onKeyup = React.useCallback(
      (e) => {
        if (e.keyCode === 27) {
          e.preventDefault();
          if (onDismiss && typeof onDismiss === "function") {
            onDismiss();
          }
        }
      },
      [onDismiss]
    );
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "uitk-dialog-layer uitk-dialog-layer-responsive layer-overlay-active",
        id,
        onClick,
        onKeyUp: onKeyup,
        ref
      },
      children || null
    );
  };
  return EgenciaLayerComponent;
}
const egenciaDialogContext = (onDismiss, locationHashUpdate = true) => {
  const dialogContext = {
    useDialogControl: (id, dialogQueryKey, isOpen, setIsOpen) => ({
      // eslint-disable-next-line new-cap
      ComponentFactory: EgenciaLayer(
        id,
        isOpen,
        setIsOpen,
        onDismiss,
        dialogQueryKey,
        locationHashUpdate
      ),
      actions: {
        openDialog: () => {
          if (dialogQueryKey && window?.location && locationHashUpdate !== false) {
            window.location.hash = `${dialogQueryKey}=open`;
          }
          setIsOpen(true);
        },
        closeDialog: () => setIsOpen(false),
        toggleDialog: () => setIsOpen(!isOpen)
      }
    })
  };
  return dialogContext;
};
export const EgenciaDialogProvider = ({
  onDismiss,
  children,
  locationHashUpdate
}) => /* @__PURE__ */ React.createElement(DialogControlProvider, { value: egenciaDialogContext(onDismiss, locationHashUpdate) }, children);
